module.exports = __webpack_public_path__ + "static/media/fluxogramas-icon.ef712b62.svg";